import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormControl } from '@angular/forms';
import { Observable } from 'rxjs';
import { map, startWith } from 'rxjs/operators';

@Component({
  selector: 'ml-filterable-select',
  template: `
    <mat-form-field appearance="fill" class="full-width">
      <mat-label>{{ title | translate | titlecase }}</mat-label>
      <mat-select [formControl]="control">
        <div class="filter filter--sticky" fxLayout="row">
          <mat-icon
            matPrefix
            class="filter--margin"
            svgIcon="search"
          ></mat-icon>
          <input
            matInput
            placeholder="{{ 'filter' | translate | titlecase }}"
            type="text"
            autocomplete="off"
            [formControl]="filterControl"
            (keydown.Space)="$event.stopPropagation()"
          />
        </div>
        <mat-option class="filter__clear" *ngIf="clear && control.value">
          {{ 'clear' | translate | titlecase }}
        </mat-option>
        <mat-option
          *ngFor="let item of (filteredItems | async)"
          [value]="item.id"
        >
          <span *ngIf="translate"> {{ displayFn(item) | translate }} </span>
          <span *ngIf="!translate"> {{ displayFn(item) }} </span>
        </mat-option>
      </mat-select>
    </mat-form-field>
  `,
  styleUrls: ['./filterable-select.component.scss']
})
export class FilterableSelectComponent implements OnInit {
  filterControl: FormControl = new FormControl();
  filteredItems: Observable<any[]>;
  options: any[];

  @Output() select = new EventEmitter();

  @Input() title: string;
  @Input() clear: boolean;
  @Input() translate = false;

  @Input('options') set items(options: any[]) {
    if (options) {
      this.initFilter();
      this.options = options;
    }
  }
  @Input() control: FormControl;
  @Input() displayFn = item => item.name;

  constructor() {}

  ngOnInit() {
    this.control.valueChanges.subscribe(value => {
      this.select.emit(value);
    });
  }

  initFilter() {
    this.filteredItems = this.filterControl.valueChanges.pipe(
      startWith(''),
      map(filterBy =>
        filterBy ? this.filteredBy(filterBy) : this.options.slice()
      )
    );
  }

  filteredBy(filterBy: string) {
    if (!this.options) {
      return [];
    }

    return this.options.filter(
      item =>
        this.displayFn(item)
          .toLowerCase()
          .indexOf(filterBy.toLowerCase()) > -1
    );
  }
}
